import { useClientScope, CLIENT_SCOPE_ALL } from "../contexts/ClientScopeContext";
import { T } from "../theme";

export const ClientPicker = () => {
  const { loading, availableClients, canPickAll, selected, setSelected, organization, edition } = useClientScope();

  // In in-house deployments there is only one client (the company itself) and
  // no firm/client distinction to expose. Suppress the picker entirely.
  if (edition === "in_house") return null;

  if (loading) {
    return (
      <div style={{ fontSize: 11, color: T.txD, padding: "6px 0" }}>Loading scope…</div>
    );
  }

  // Nothing to pick from — render nothing rather than an empty dropdown.
  if (availableClients.length === 0 && !canPickAll) return null;

  // Single-client users (typically client-org with one grant) get a static
  // badge instead of a dropdown — there is nothing to choose.
  const lockedSingle = !canPickAll && availableClients.length === 1;
  if (lockedSingle) {
    const c = availableClients[0];
    return (
      <div style={{ fontSize: 11, color: T.txD, marginBottom: 8 }}>
        <div style={{ fontSize: 10, textTransform: "uppercase", letterSpacing: 0.4, marginBottom: 3, color: T.txD }}>Client</div>
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 6,
          padding: "4px 10px", borderRadius: 999,
          backgroundColor: T.accS, color: T.tx, fontSize: 12, fontWeight: 600,
        }}>
          {c.name}
        </div>
      </div>
    );
  }

  const value = selected === CLIENT_SCOPE_ALL ? CLIENT_SCOPE_ALL : String(selected);

  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontSize: 10, textTransform: "uppercase", letterSpacing: 0.4, marginBottom: 4, color: T.txD }}>
        Client context
      </div>
      <select
        value={value}
        onChange={(e) => {
          const v = e.target.value;
          setSelected(v === CLIENT_SCOPE_ALL ? CLIENT_SCOPE_ALL : Number(v));
        }}
        style={{
          width: "100%",
          padding: "6px 8px",
          fontSize: 13,
          borderRadius: 6,
          border: `1px solid ${T.brd}`,
          backgroundColor: "#FFFFFF",
          color: T.tx,
          fontFamily: "inherit",
        }}
      >
        {canPickAll && <option value={CLIENT_SCOPE_ALL}>All clients</option>}
        {availableClients.map((c) => (
          <option key={c.id} value={String(c.id)}>{c.name}</option>
        ))}
      </select>
      {organization && organization.org_type !== "internal" && (
        <div style={{ fontSize: 10, color: T.txD, marginTop: 3 }}>
          {organization.org_type === "firm" ? "Firm: " : "Org: "}{organization.name}
        </div>
      )}
    </div>
  );
};
